import React from 'react';
import { useForm } from 'react-final-form';

import CTAButton from '../../../../../CTAButton/CTAButton';

interface Props {
  hostile: React.MutableRefObject<boolean>;
  showHostilePrompt: () => void;
}

const SubmitButton: React.FC<Props> = ({ hostile, showHostilePrompt }) => {
  const form = useForm();

  const handleClick = () => {
    if (hostile.current) {
      showHostilePrompt();
    } else {
      form.submit();
    }
  };

  return <CTAButton onClick={handleClick} type="button" />;
};
export default SubmitButton;
